import { Avatar, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  auth,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  sendEmailVerification,
  PhoneAuthProvider,
  RecaptchaVerifier,
  getMultiFactorResolver,
  PhoneMultiFactorGenerator,
} from '../../../firebase/index';
import { useMainFrameState } from '../MainFrame';
import { mainLogoDimen, toPixel } from '../styles/dimensions';

//changes from shylu//
function CurrentUser() {
  const [displayName, setDisplayName] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      console.log(`Auth state changed`, user, auth);
      // console.log(user.displayName,'user')
      if (user) {
        setDisplayName(user.displayName);
      } else {
        setDisplayName(null);
      }
    });

    console.log(`APPJS AGAIN`, unsubscribe);

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <>
      <Box sx={{ fontSize: 14.5 }}>
        {displayName?.substring(0, displayName?.lastIndexOf(' '))}
      </Box>
    </>
  );
}
//changes from shylu//
const AvatarDesign = () => {
  const { mainDrawerOpen } = useMainFrameState();

  return (
    <Box
      sx={{
        // display: "flex",
        // flexDirection: "column",
        // padding:1
        padding: 0,
      }}
    >
      <Avatar
        sx={{
          width: toPixel(mainLogoDimen.closed.width),
          height: toPixel(mainLogoDimen.closed.height),
        }}
      >
        {auth?.currentUser?.displayName.slice(0, 1)}
      </Avatar>
    </Box>
  );
};

export const mainDrawerJson = [
  {
    icon: 'space_dashboard',
    title: 'Dashboard',
    name: 'dashboard',
    link: 'dashboard',
    submenu: [],
    isActive: false,
    // structure: ['ACTION_AB_BB'],
  },
  {
    icon: 'calendar_month',
    title: 'Appointments',
    name: 'appointments',
    link: 'appointments',
    submenu: [],
    isActive: false,
    // structure: ['ACTION_AB_BB_TB_RF_LF'],
  },
  {
    icon: 'person_pin',
    title: 'Practitioner',
    name: 'practitioners',
    link: 'practitioner',
    submenu: [],
    isActive: false,
    // structure: ['ACTION_AB_BB_TB_RF_LF'],
  },
  {
    icon: 'local_hospital',
    title: 'EHR',
    name: 'ehr',
    link: 'ehr',
    submenu: [],
    isActive: false,
    // structure: ['ACTION_AB_BB_TB_RF_LF'],
  },
  // {
  //   icon: "space_dashboard",
  //   title: "Dashboard",
  //   name: "dashboard",
  //   link: "dashboard",
  //   submenu: [],
  // },
  {
    icon: 'corporate_fare',
    title: 'Organization',
    name: 'organizations',
    link: 'organizations',
    submenu: [],
    isActive: false,
    // structure: ['ACTION_AB_BB_TB_RF_LF'],
  },
  {
    icon: 'add_location',
    title: 'Locations',
    name: 'locations',
    link: 'locations',
    submenu: [],
    isActive: false,
    // structure: ['ACTION_AB_BB_TB_RF_LF'],
  },
  // {
  //   icon: 'account_balance',
  //   title: 'Resource Management',
  //   name: 'ResourceManagement',
  //   link: 'resource-management',
  //   submenu: [],
  //   isActive: false,
  //   // structure: ['ACTION_AB_BB_TB_RF_LF'],
  // },
  {
    icon: 'people_alt',
    title: 'Contacts',
    name: 'contacts',
    link: 'contacts',
    submenu: [],
    isActive: false,
    // structure: ['ACTION_AB_BB_TB_RF_LF'],
  },
  {
    icon: 'description',
    title: 'Forms',
    name: 'form',
    link: 'forms',
    submenu: [],
    isActive: false,
    // structure: ['ACTION_AB_BB_TB_RF_LF'],
  },
  {
    icon: 'assessment',
    title: 'Report Templates',
    name: 'reportsTemplates',
    link: 'report-templates',
    submenu: [],
    isActive: false,
    // structure: ['ACTION_AB_BB_TB_RF_LF'],
  },
  // {
  //     icon: 'border_color',
  //     title: 'Practitioner Role',
  //     name: 'PractitionerRole',
  //     link: 'practitionerRole',
  //     submenu: []
  // },

  // {
  //   icon: "book_online",
  //   title: "Appointments",
  //   name: "appointments",
  //   link: "appointments",
  //   submenu: [],
  // },
  // {
  //   icon: "space_dashboard",
  //   title: "Meds",
  //   name: "meds",
  //   link: "",
  //   submenu: [
  //     {
  //       icon: "medication",
  //       title: "Doctors",
  //       name: "doctors",
  //       link: `doctors`,
  //     },
  //     {
  //       icon: "people_alt",
  //       title: "Vendors",
  //       name: "vendors",
  //       link: "",
  //     },
  //   ],
  // },
  {
    icon: 'monetization_on',
    title: 'Claims',
    name: 'claim',
    link: 'claims',
    submenu: [],
  },
  // {
  //   icon: 'monetization_on',
  //   title: 'Claims',
  //   name: 'claim',
  //   link: 'claims',
  //   submenu: [],
  //   isActive: false,
  //   // structure: ['ACTION_AB_BB_TB_RF_LF'],
  // },
  {
    icon: 'receipt_long',
    title: 'Invoice',
    name: 'invoice',
    link: 'invoice',
    submenu: [],
    isActive: false,
    // structure: ['ACTION_AB_BB_TB_RF_LF'],
  },
  // {
  //   icon: "book_online",
  //   title: "Faq",
  //   name: "faq",
  //   link: "faqs",
  //   submenu: [],
  // },
  //  {
  //     icon: 'people_alt',
  //     title: 'Contacts',
  //     name: 'contacts',
  //     link: 'contacts',
  //     submenu: []
  // }, {
  //     icon: 'book_online',
  //     title: 'Faq',
  //     name: 'faq',
  //     link: 'faqs',
  //     submenu: []
  // },
  // {
  //     icon: 'description',
  //     title: 'ERA',
  //     name: 'era',
  //     link: 'era',
  //     submenu: []
  // },
  // {
  //   icon: "local_hospital",
  //   title: "EHR",
  //   name: "ehr",
  //   link: "ehr",
  //   submenu: [],
  // },

  /*  {
    icon: "receipt",
    title: "Invoice",
    name: "invoice",
    link: "invoice",
    submenu: [],
  }, */

  // {
  //   icon: "help",
  //   title: "FHIR",
  //   name: "fhir",
  //   link: "fhir",
  //   submenu: [],
  // },

  {
    icon: 'manage_history',
    title: 'Exports',
    name: 'export',
    link: 'exports',
    submenu: [],
    isActive: false,
    // structure: ['ACTION_AB_BB_TB_RF_LF'],
  },
  {
    icon: 'settings',
    title: 'Account',
    name: 'accounts',
    link: 'account',
    submenu: [],
    isActive: false,
    // structure: ['ACTION_AB_BB_TB_RF_LF'],
  },
  {
    icon: 'info',
    title: 'About',
    name: 'About',
    link: 'about',
    submenu: [],
    isActive: false,
    // structure: ['ACTION_AB_BB_TB_RF_LF'],
  },
  {
    //new one//
    icon: <AvatarDesign />,
    title: <CurrentUser />,
    name: 'username',
    link: 'current username',
    isAvatar: true,
    submenu: [],
    isActive: false,
    // structure: ['ACTION_AB_BB_TB_RF_LF'],
    //new one//
  },
  {
    icon: 'logout',
    title: 'Logout',
    name: 'Logout',
    link: 'logout',
    submenu: [],
    isActive: false,
  },
];
// export const mainDrawerJson = [{
//     icon: 'space_dashboard',
//     title: 'Dashboard',
//     name: 'dashboard',
//     link: 'dashboard',
//     submenu: [],
//     actions: [ACTION_OPEN_TOOLBAR,
//         ACTION_OPEN_LEFT_FLOATING_DRAWER,
//         ACTION_CLOSE_RIGHT_FLOATING_DRAWER]
// }, {
//     icon: 'book_online',
//     title: 'Appointments',
//     name: 'appointments',
//     link: '',
//     submenu: []
// }, {
//     icon: 'add_circle',
//     title: 'Meds',
//     name: 'meds',
//     link: 'meds',
//     submenu: [{
//         icon: 'medication',
//         title: 'Doctors',
//         name: 'doctors',
//         link: `doctors`,
//     }, {
//         icon: 'location_on',
//         title: 'Locations',
//         name: 'locations',
//         link: '',
//     }, {
//         icon: 'people_alt',
//         title: 'Vendors',
//         name: 'vendors',
//         link: '',
//     }]
// }, {
//     icon: 'personal_injury',
//     title: 'Patients',
//     name: 'patients',
//     link: 'patients',
//     submenu: []
// }, {
//     icon: 'admin_panel_settings',
//     title: 'Admin',
//     name: 'admin',
//     link: '',
//     submenu: []
// }, {
//     icon: 'paid',
//     title: 'Payment',
//     name: 'payment',
//     link: '',
//     submenu: []
// }]
